export default __webpack_public_path__ + "images/comment-block.svg";